import { Box, ChakraProps } from "@chakra-ui/react";

import NodeList from "./NodeList";
import { incrementRecursive } from "./utils";

export interface TreeNode {
  key?: string | number; // Local ID
  id?: string | number;
  nome: string;
  readOnly?: boolean;
  operacao: number;
  ordem: number;
  breadcrumb: string;
  items?: TreeNode[];
  codigoIntegracao?: string | null;
  podeClassificarConta?: boolean | null;
  ativo?: boolean | null;
  centroDeCustoId?: string | null;
  centroDeCusto?: {
    id: string;
    nome: string;
  } | null;
}

interface TreeProps extends ChakraProps {
  data: TreeNode[] | any;
  edit?: boolean;
  tenant?: string;
}

export default function AccountPlanTree({
  data,
  edit,
  tenant,
  ...props
}: TreeProps) {
  return (
    <Box {...props}>
      <NodeList
        tenant={tenant}
        nodelist={incrementRecursive(data, "1")}
        edit={edit}
      />
    </Box>
  );
}
